<ng-container *ngIf="configuration$ | async as conf">
  <ng-container *ngIf="node$ | async as node">
    <ssab-cx-navigation-ui
      [currentNode]="node"
      [class]="styleClass$ | async"
      [otherServicesAvailable]="!!(conf.otherServicesAvailable)">
    </ssab-cx-navigation-ui>
  </ng-container>
</ng-container>
